const tinyTextStyles = {
    color: "black",
    fontSize: "desktopBodyTextTiny",
    fontWeight: "semibold",
};

export const styles = {
    fieldsWrapper: {
        w: {
            base: "100%",
            md: "60%",
        },
        mt: 8,
    },
    formLabel: {
        fontWeight: "bold",
        fontSize: ["mobileBodyB2", "desktopBodyB2"],
    },
    policyAgreementLabel: {
        m: 0,

        "& p": {
            ...tinyTextStyles,
        },

        "& span": {
            ...tinyTextStyles,
        },
    },
    formInput: {
        fontWeight: "bold",
        color: "black",
        // The mobile field is scaled down to avoid the iOS input zoom, so this height is
        // pre-scale: 55px renders as ~48px. Check @packages/ui/src/components/forms/input/Input.styles for more information
        h: ["55px", 10.4],
        _readOnly: {
            bg: "gray.50",
            cursor: "not-allowed",
            borderColor: "gray.400",
        },
        _selected: {
            outline: "none",
        },
        ['[role="group"][data-success="true"] &']: {
            borderColor: "green.900",
        },
    },
    // InputGroup only pads a direct Input child, and Formik's Field wraps ours, so the text
    // would run under the icon. Matches formInput.h, the width of the right element.
    formInputWithRightIcon: {
        pe: ["55px", 10.4],
    },
    icon: {
        success: {
            color: "green.900",
        },
        invalid: {
            color: "red.500",
        },
    },
    birthdate: {
        fontWeight: "bold",
        color: "black",
        _placeholder: { color: "gray.200" },
        _selected: {
            outline: "none",
        },
    },
    formInputDisabled: {
        bg: "gray.50",
    },
    genderField: {
        size: "lg",
        fontWeight: "normal",
        fontSize: ["mobileBodyB2", "desktopBodyB2"],
        color: "black",
        _hover: {
            textDecoration: "none",
        },
    },
    errorGroupMessage: {
        color: "red.200",
        fontSize: "desktopBodyTextTiny",
        fontWeight: "bold",
        mt: 2,
    },
    countryCodeField: {
        color: "gray.800",
        fontWeight: "bold",
        h: ["55px", 10.4],
        border: "1px solid gray.100",
        bg: "gray.50",
    },
};
